import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
});

// 请求拦截器：自动添加 JWT token
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器：处理 401 未授权错误
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('isLoggedIn');
      // 已在登录页时不再跳转，避免登录失败时整页刷新冲掉错误提示
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

/**
 * 从 JWT token 中解码用户信息（不验证签名，仅解析 payload）
 */
function parseJwtPayload(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

export const authApi = {
  login(data) {
    return api.post('/auth/login', data);
  },

  checkAuth() {
    return api.get('/auth/check');
  },

  getCurrentUser() {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const payload = parseJwtPayload(token);
    if (!payload) return null;
    return {
      username: payload.sub,
      displayName: payload.displayName || payload.sub,
      role: payload.role
    };
  },

  isLoggedIn() {
    return localStorage.getItem('isLoggedIn') === 'true';
  },

  logout() {
    const token = localStorage.getItem('token');
    localStorage.removeItem('token');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('role');
    localStorage.removeItem('mustChangePassword');
    if (token) {
      api.post('/auth/logout').catch(() => {});
    }
  }
};

export default api;